import store from './store'

const apiUrl = process.env.VUE_APP_API_ENDPOINT

export default {
  async get(url) {
    return this.httpJSON('GET', url, null)
  },

  async post(url, body) {
    return this.httpJSON('POST', url, body)
  },

  async patch(url, body) {
    return this.httpJSON('PATCH', url, body)
  },

  async delete(url) {
    return this.httpJSON('DELETE', url)
  },

  async upload(file) {
    const headers = {
      Accept: 'application/json',
    }
    const token = localStorage.getItem('token')
    if (token) headers.Authorization = `Bearer ${token}`

    const data = new FormData()
    data.append('file', file)

    const res = await fetch(`${apiUrl}/upload`, {
      method: 'POST',
      headers,
      body: data,
    })

    return res.json()
  },

  async httpJSON(method, url, body) {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
    const token = localStorage.getItem('token')
    if (token) headers.Authorization = `Bearer ${token}`

    const res = await fetch(`${apiUrl}${url}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : null,
    })

    if (res.status === 204) { // empty response
      return null
    }

    if (!res.ok) {
      if (res.status === 401) { // unauthorized
        store.dispatch('logout')
      }

      if (res.status === 400) {
        const data = await res.json()
        throw new Error(data.message)
      }

      if (res.status === 500) {
        const data = await res.json()
        // We assume that most "EntityNotFound" errors are the failed logins.
        // But it could also be that the location is not found. TODO: Improve API with better error handling.
        if (data.name === 'EntityNotFound') { // invalid user-email
          throw new Error('Invalid email')
        }
      }

      const text = await res.text()
      throw new Error(`API error (${res.status}): ${text}`)
    }

    return res.json()
  },
}
